import { render, staticRenderFns } from "./RequestAssistance.vue?vue&type=template&id=4622a7d0&scoped=true"
import script from "./RequestAssistance.vue?vue&type=script&lang=js"
export * from "./RequestAssistance.vue?vue&type=script&lang=js"
import style0 from "./RequestAssistance.vue?vue&type=style&index=0&id=4622a7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622a7d0",
  null
  
)

export default component.exports